import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_ARITHMETIC_FUNCTION_TYPES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';
import PlainStringField from '../../components/PlainStringField';

import { RolesRuleValues } from '../types';

type RolesRuleFieldProps = {
    value: RolesRuleValues;
    onChange: (value: RolesRuleValues) => void;
};

const RolesRuleField = ({ value, onChange }: RolesRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.key || null,
        level1: value.level?.[1]?.data.value || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: RolesRuleFieldProps['value']['level'] = [
                newLevelValue.level0 ? { data: { key: newLevelValue.level0 } } : undefined,
                newLevelValue.level1 ? { data: { value: newLevelValue.level1 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <>
            <SelectField
                autoWidth
                options={[
                    {
                        label: <FormattedMessage id="Rules.level.one_of_cs" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.ONE_OF,
                    },
                    {
                        label: <FormattedMessage id="Rules.level.contains" />,
                        value: RULE_ARITHMETIC_FUNCTION_TYPES.CONTAINS,
                    },
                ]}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
            {levelValue.level0 ? (
                <PlainStringField value={levelValue.level1 || ''} onChange={handleOnChange(1)} />
            ) : null}
        </>
    );
};

export default RolesRuleField;
